import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// COMPONENTES
import { EspecialidadComponent } from './especialidad/especialidad.component';
import { FechaTurnoComponent } from './fecha-turno/fecha-turno.component';
import { ZonaGeograficaComponent } from './zona-geografica/zona-geografica.component';
import { SeleccionUbicacionPrestadorComponent } from './seleccion-ubicacion-prestador/seleccion-ubicacion-prestador.component';
import { ResumenOrderPrestadorComponent } from './resumen-order/resumen-order.component';
import { OrderResponsePrestadorComponent } from './order-response-prestador/order-response-prestador.component';
import { OrderConfirmPrestadorComponent } from './order-confirm-prestador/order-confirm-prestador.component';
import { ReviewPrestadorComponent } from './review-prestador/review-prestador.component';

// DATEPICKER :: Inicio //
import { NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { registerLocaleData } from "@angular/common";
import localeEs from "@angular/common/locales/es-AR";
import localeEsExtra from "@angular/common/locales/extra/es-AR";
import { OrderDetailPrestadorComponent } from './order-detail-prestador/order-detail-prestador.component';
registerLocaleData(localeEs, "es-AR", localeEsExtra);
// DATEPICKER :: Fin //
@NgModule({
  declarations: [
    EspecialidadComponent,
    FechaTurnoComponent,
    ZonaGeograficaComponent,
    SeleccionUbicacionPrestadorComponent,
    ResumenOrderPrestadorComponent,
    OrderResponsePrestadorComponent,
    OrderConfirmPrestadorComponent,
    ReviewPrestadorComponent,
    OrderDetailPrestadorComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgbDatepicker,
  ],
  providers: [{ provide: LOCALE_ID, useValue: "es-AR"}]
})
export class OrderPrestadorModule { }
